'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import ViverseButton from '@/components/ViverseButton';
import { DEFAULT_VIVERSE_ORIGIN } from '@/constants/domain';
import freeOnViverseAlphaputt from '@/public/images/viverse-plus/free-on-viverse-alphaputt.png';
import freeOnViverseBackToBed from '@/public/images/viverse-plus/free-on-viverse-back-to-bed.png';
import freeOnViverseDeliciousEmily from '@/public/images/viverse-plus/free-on-viverse-delicious-emily.png';
import freeOnViverseFigment from '@/public/images/viverse-plus/free-on-viverse-figment.png';
import freeOnViverseHeavenDust2 from '@/public/images/viverse-plus/free-on-viverse-heaven-dust-2.png';
import freeOnViverseOvivo from '@/public/images/viverse-plus/free-on-viverse-ovivo.png';
const games = [{
  key: 'alphaputt',
  href: `${DEFAULT_VIVERSE_ORIGIN}/NT8vChy`,
  image: freeOnViverseAlphaputt,
  imageClassName: 'object-center'
}, {
  key: 'ovivo',
  href: `${DEFAULT_VIVERSE_ORIGIN}/iv9gsHj`,
  image: freeOnViverseOvivo,
  imageClassName: 'object-[50%_70%]'
}, {
  key: 'heaven-dust-2',
  href: `${DEFAULT_VIVERSE_ORIGIN}/G5GXFLa`,
  image: freeOnViverseHeavenDust2,
  imageClassName: 'object-[50%_67%]'
}, {
  key: 'figment',
  href: `${DEFAULT_VIVERSE_ORIGIN}/bNTvNxX`,
  image: freeOnViverseFigment,
  imageClassName: 'object-[50%_29%]'
}, {
  key: 'delicious-emily',
  href: `${DEFAULT_VIVERSE_ORIGIN}/vk4yFfy`,
  image: freeOnViverseDeliciousEmily,
  imageClassName: 'object-center'
}, {
  key: 'back-to-bed',
  href: `${DEFAULT_VIVERSE_ORIGIN}/uzMBdJh`,
  image: freeOnViverseBackToBed,
  imageClassName: 'object-[50%_29%]'
}] as const;
export default function FreeOnViverseSection() {
  const $ = _c(49);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="pointer-events-none absolute top-[146px] left-1/2 h-36 w-[424px] -translate-x-1/2 rounded-full bg-[#fd8eff] opacity-40 blur-[140px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 16
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true,
      amount: 0.2
    };
    t4 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("plus.free-on-viverse.eyebrow");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <p className="text-vive-primary-40 text-xs leading-4 font-extrabold tracking-[6.15px] uppercase">{t5}</p>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("plus.free-on-viverse.title");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("plus.free-on-viverse.title-highlight");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <span className="bg-[linear-gradient(89deg,#53fff6_0%,#f3deff_0%,#ff82fb_92%)] bg-clip-text text-transparent">{t8}</span>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <h2 className="mt-5 mb-4 text-center text-3xl leading-10 font-extrabold tracking-[0.15px] text-[#eeeef0] sm:text-[38px] md:mb-12">{t7}{" "}{t9}</h2>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t("plus.free-on-viverse.description");
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <p className="text-vive-primary-30 mt-4 max-w-xl text-center text-[15px] leading-[26px]">{t11}</p>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t12 || $[24] !== t6) {
    t13 = <motion.div className="flex flex-col items-center" initial={t1} whileInView={t2} viewport={t3} transition={t4}>{t6}{t10}{t12}</motion.div>;
    $[22] = t10;
    $[23] = t12;
    $[24] = t6;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = games.map((game, index) => <motion.div key={game.key} className="flex flex-col gap-4 rounded-[20px] bg-white/5 p-6" initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.6,
      ease: "easeOut",
      delay: (index + 1) * 0.08
    }}><div className="relative h-[100px] w-full overflow-hidden rounded-2xl"><Image src={game.image} alt="" fill={true} sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" className={`object-cover ${game.imageClassName}`} /></div><div className="flex flex-col gap-3"><h3 className="text-sm leading-[22px] font-semibold tracking-[0.15px] text-[#eeeef0]">{t(`plus.free-on-viverse.games.${game.key}.title`)}</h3><p className="text-vive-primary-30 line-clamp-3 text-xs leading-4 tracking-[0.15px]">{t(`plus.free-on-viverse.games.${game.key}.description`)}</p><p className="text-vive-primary-40 text-[10px] leading-[15px] whitespace-nowrap">{t(`plus.free-on-viverse.games.${game.key}.rating`)}</p></div><div className="flex items-center justify-between gap-4"><ViverseButton asChild={true} size="small2" className="shrink-0"><a href={game.href} target="_blank" rel="noreferrer">{t("plus.free-on-viverse.cta")}</a></ViverseButton></div></motion.div>);
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <div className="mt-14 grid w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">{t14}</div>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  let t17;
  let t18;
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      opacity: 0,
      y: 16
    };
    t17 = {
      opacity: 1,
      y: 0
    };
    t18 = {
      once: true,
      amount: 0.2
    };
    t19 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
  } else {
    t16 = $[30];
    t17 = $[31];
    t18 = $[32];
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t) {
    t20 = t("plus.player-reach.count");
    $[34] = t;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t20) {
    t21 = <p className="bg-[linear-gradient(166deg,#c22757_0%,#c961d9_100%)] bg-clip-text text-5xl leading-none font-extrabold tracking-[0.4px] text-transparent sm:text-[64px] sm:leading-20">{t20}</p>;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t) {
    t22 = t("plus.player-reach.description");
    $[38] = t;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t22) {
    t23 = <p className="text-vive-primary-30 mt-4 text-sm leading-6 tracking-[0.2px] whitespace-pre-line sm:text-base">{t22}</p>;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t21 || $[43] !== t23) {
    t24 = <motion.div className="mt-32 flex w-full flex-col items-center text-center sm:mt-36" initial={t16} whileInView={t17} viewport={t18} transition={t19}>{t21}{t23}</motion.div>;
    $[42] = t21;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t13 || $[46] !== t15 || $[47] !== t24) {
    t25 = <div className="relative px-6 py-16 sm:px-12 sm:py-20">{t0}<div className="relative mx-auto flex max-w-[1128px] flex-col items-center">{t13}{t15}{t24}</div></div>;
    $[45] = t13;
    $[46] = t15;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  return t25;
}